export default function buildCoalBarConfig (xAxis, data) {
  return {
    tooltip: {
      trigger: 'axis',
      show: true
    },
    legend: {
      top: 0,
      textStyle: {
        color: '#FFFFFF',
        fontSize: 10
      },
      itemWidth: 20,
      itemHeight: 10
    },
    grid: {
      left: '0',
      bottom: '0',
      width: '90%',
      height: '90%',
      containLabel: true
    },
    color: ['#15AEFE', '#FCB268'],
    yAxis: {
      type: 'category',
      axisLabel: {
        color: '#fff'
      },
      data: xAxis
    },
    xAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        formatter: '{value}'
      }
    },
    series: data
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_coal_bar.js